import React from 'react'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../../../../auth/useAuth'
function UserMenuSettings() {
  const { t } = useTranslation('common')
  const { signout } = useAuth()
  const logout = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault()
    signout()
  }

  return (
    <a className="userInfo" onClick={(e) => logout(e)}>
      <i className="icon-shut-down" />
      {t('SIGN_OUT')}
    </a>
  )
}

export default UserMenuSettings
